import React from 'react';
import { Hero } from '../components/Hero';
import { OpeningHook } from '../components/OpeningHook';
import { Problem } from '../components/Problem';
import { FailedMethods } from '../components/FailedMethods';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { Proof } from '../components/Proof';
import { TrustSection } from '../components/TrustSection';
import { FAQ } from '../components/FAQ';
import { BuyWithPeace } from '../components/BuyWithPeace';
import { PriceBlock } from '../components/PriceBlock';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-cream selection:bg-periwinkle/30" data-id="element-198">
      <Hero data-id="element-199" />
      <OpeningHook data-id="element-200" />
      <Problem data-id="element-201" />
      <FailedMethods data-id="element-202" />
      <UniqueMechanism data-id="element-203" />
      <WhatYouGet data-id="element-204" />
      <WhoIsFor data-id="element-205" />
      <HowItWorks data-id="element-206" />
      <Proof data-id="element-207" />
      <TrustSection data-id="element-208" />
      <FAQ data-id="element-209" />
      <BuyWithPeace data-id="element-210" />
      <PriceBlock data-id="element-211" />
      <FinalCTA data-id="element-212" />
      <Footer data-id="element-213" />
    </main>;
}